import type { TRuleWithTheme } from '@/styles/theme';

// Escapes the sidebar's 1.5rem padding to an ~8px gutter, like MenuItem.
export const container: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
    marginRight: '-1rem',
    marginLeft: '-1rem',
});

export const link: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(8),
    height: '32px',
    padding: `0 ${theme.spacing(12)}`,
    borderRadius: theme.spacing(8),
    ...theme.typography.ParagraphSmallMedium,
    color: theme.colors.foregroundsPrimary,
    textDecoration: 'none',
    transition: 'background-color 0.15s ease',

    ':hover': {
        backgroundColor: theme.colors.listItemHoverBg,
        color: theme.colors.foregroundsPrimary,
    },
});

// Only the resets a <button> needs; the shared `link` rule still owns the typography.
export const linkButton: TRuleWithTheme = () => ({
    appearance: 'none',
    border: 'none',
    background: 'none',
    width: '100%',
    fontFamily: 'inherit',
    textAlign: 'left',
    cursor: 'pointer',
});

export const icon: TRuleWithTheme = () => ({
    flexShrink: 0,
    width: '16px',
    height: '16px',
});
